import React, { useState, useRef, useEffect } from 'react';
import JoditEditor from 'jodit-react';
import Button from "react-bootstrap/Button";
import { addCarePlanDocument } from "../../../schemas";
import { useFormik } from "formik";
import pdfIcon from "../../../assets/images/icons/pdfIcon.svg";
import wordIcon from "../../../assets/images/icons/wordIcon.svg";
import { renderToString } from 'react-dom/server';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  POST_CARE_PLAN_DOC_URL,
  ADMIN_ID,
  BASE_URL,
  ADMIN_AUTH_TOKEN,
  UPLOAD_REFERENCE_DOCUMENT_URL,

} from "../../../env";
import {
  postRecords,
  catchAsync,
  isSuccess,
  toastSuccessMessages,
  toastErrorMessages,
} from "../../../helper/helper";
import CustomSelect from "../../../components/forms-fields/CustomSelectStaffMembers";
import Modal from 'react-bootstrap/Modal';
import Table from 'react-bootstrap/Table';
import TextArea from '../../../components/forms-fields/TextArea';
import SelectBox from '../../../components/forms-fields/SelectBox';
import Input from '../../../components/forms-fields/Input';
import eventClose from "../../../assets/images/icons/eventClose.svg";
import eventAdd from "../../../assets/images/icons/eventAdd.svg";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import infoIcon from "../../../assets/images/icons/infoIcon.svg";

function AddCarePlanPopUp({ modalPopupData, handelModalPopupClose }) {

  const tooltipText = "Your tooltip text here"; // Define it here

  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      {tooltipText}
    </Tooltip>
  );

  const storedUserDetails = localStorage.getItem("profileUserDetails");
  const userDetails = JSON.parse(storedUserDetails);

  const storedIncidentDetail = localStorage.getItem("carePlanDetail");
  const carePlanDetail = JSON.parse(storedIncidentDetail);
  // const [uploadedFilePath, setUploadedFilePath] = useState("");
  const [fileSizeError, setFileSizeError] = useState(false);

  const [isSubmitButtonClicked, setIsSubmitButtonClicked] = useState(false);
  const [isToastAddPbsPlans, setIsToastAddPbsPlans] = useState(false);

  // Editor Variable
  const [sectionContentID, setSectionContentID] = useState(modalPopupData?.sectionId);
  const [sectionContentData, setSectionContentData] = useState(modalPopupData?.fieldValueContent);
  const [myContactListStatus, setMyContactListStatus] = useState(false);


  const editor = useRef(null);

  const [suFormData, setSuFormData] = useState({
    userId: userDetails?._id,
    addedby: ADMIN_ID,
    [modalPopupData?.sectionId]: modalPopupData?.fieldValueContent || "",

  });

  const {
    values,
    errors,
    touched,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue,
  } = useFormik({
    initialValues: suFormData,
    validationSchema: addCarePlanDocument,
    onSubmit: async (values) => {
      try {
        setIsSubmitButtonClicked(true);
        await postEditPbsPlansFormData(values);
      } catch (error) {

      }
    },
  });

  const processPostRecords = (method, data) => {
    if (data?.status !== isSuccess) {
      setIsToastAddPbsPlans(true);
      toastErrorMessages(toast.error, data?.message, "", 500, 500);
      setIsSubmitButtonClicked(false);
    } else if (
      method === "postEditPbsPlansFormData" &&
      data?.status === isSuccess
    ) {
      setIsToastAddPbsPlans(true);
      toastSuccessMessages(toast.success, data?.message, "/view-care-plan", 500, 500);
      setIsSubmitButtonClicked(false);
      setTimeout(() => {
        handelModalPopupClose()
      }, 800);
    }
  };

  const postEditPbsPlansFormData = catchAsync(async (req, res) => {
    let updatedValues;
    if (myContactListStatus) {
      updatedValues = {
        ...values,
        [modalPopupData?.sectionId]: sectionContentData,
        myContacts: myContactsList.map(row => ({
          id: row?.id,
          name: row?.name,
          relationship: row?.relationship,
          address: row?.address,
          email: row?.email,
          phoneNumber: row?.phoneNumber,
        })),
      }
    } else {
      updatedValues = {
        ...values,
        [modalPopupData?.sectionId]: sectionContentData,
      }
    }

    const response = await postRecords(POST_CARE_PLAN_DOC_URL, updatedValues);
    setIsSubmitButtonClicked(false);
    processPostRecords("postEditPbsPlansFormData", response);
  });


  const handleOnChangeEditor = (newContent) => {
    setSectionContentData(newContent)
  }

  const handleFileUpload = async (e, documentEnum) => {
    setIsSubmitButtonClicked(true);
    try {
      const file = e.target.files[0];
      const fileName = file.name; // Get the file name
      const fileType = file.type;
      const fileSize = file.size;

      // Validate file size (5MB = 1,048,576 bytes)
      if (fileSize > 5 * 1024 * 1024) {
        alert('File size exceeds 5MB');
        setFileSizeError(true);
        setIsSubmitButtonClicked(false);
        return;
      }

      // Validate file type
      if (fileType === 'application/pdf' || fileType === 'application/msword' || fileType === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') {
        const fileData = new FormData();
        fileData.append('attachements', file);
        const apiResponse = await fetch(UPLOAD_REFERENCE_DOCUMENT_URL, {
          method: "POST",
          body: fileData,
          headers: {
            Authorization: `Bearer ${ADMIN_AUTH_TOKEN}`,
          },
        });
        const resultResponse = await apiResponse.json();

        // setUploadedFilePath(resultResponse?.data);

        // Append the file link to the JoditEditor content
        const fileLink = `${BASE_URL}${resultResponse?.data[0]?.fileNameInDirectory}`;
        // const fileLinkHTML = `<p><a href="${fileLink}" target="_blank">${fileName}</a></p>`;

        let fileLinkHTML;
        if (file.type === "application/pdf") {
          fileLinkHTML = (
            <p id={resultResponse?.data[0]?.timeStamp} className="mt-2 attachedFile">
              <a href={fileLink} target="_blank" rel="noopener noreferrer">
                <img src={pdfIcon} alt={fileName} />
                <span>{fileName}</span>
                {/* {resultResponse?.data[0]?.timeStamp} */}
                {/* <span onClick={() => removeParagraph(resultResponse?.data[0]?.timeStamp)} className="removedAttachment"> x </span> */}
              </a>
            </p>
          );
        } else {
          fileLinkHTML = (
            <p id={resultResponse?.data[0]?.timeStamp} className="mt-2 attachedFile">
              <a href={fileLink} target="_blank" rel="noopener noreferrer">
                <img src={wordIcon} alt={fileName} />
                <span>{fileName}</span>
                {/* {resultResponse?.data[0]?.timeStamp} */}
                {/* <span onClick={() => removeParagraph(resultResponse?.data[0]?.timeStamp)} className="removedAttachment"> x </span> */}
              </a>
            </p>
          );
        }

        const fileLinkHTMLString = renderToString(fileLinkHTML);

        // Update editor content directly
        if (editor.current) {
          const currentContent = editor.current.value;
          const newContent = `${currentContent} ${fileLinkHTMLString}`;
          editor.current.value = newContent;
          values[modalPopupData?.sectionId] = newContent;
          setSectionContentData(newContent);
        }
      } else {
        alert('Unsupported file format');
      }
      setIsSubmitButtonClicked(false);
    } catch (error) {
      console.error("Error uploading file:", error);
      setIsSubmitButtonClicked(false);
    }
  };

  useEffect(() => {
    if (sectionContentID === "myContacts") {
      setMyContactListStatus(true)
    } else {
      setMyContactListStatus(false)
    }
  }, [sectionContentID])
  // My Contact List

  const relationshipOptions = [
    { value: "Parent", label: "Parent" },
    { value: "Niece/Nephew", label: "Niece/Nephew" },
    { value: "Sibling", label: "Sibling" },
    { value: "Child", label: "Child" },
    { value: "Spouse/Partner", label: "Spouse/Partner" },
    { value: "Grandparent", label: "Grandparent" },
    { value: "Grandchild", label: "Grandchild" },
    { value: "Aunt/Uncle", label: "Aunt/Uncle" },
    { value: "Cousin", label: "Cousin" },
    { value: "In-law", label: "In-law" },
    { value: "Friends", label: "Friends" },
    { value: "Caregiver", label: "Caregiver" },
    { value: "Guardian", label: "Guardian" }
  ];

  const [myContactsList, setMyContactsList] = useState([
    {
      id: 1,
      name: "John Smith",
      relationship: "Friend",
      address: "123 Baker Street, London, NW1 6XE",
      email: "john.smith@example.com",
      phoneNumber: "442079460958",
    },

  ]);


  const addMyContactsListRow = () => {
    const newRow = {
      id: myContactsList.length + 1,
      name: "",
      relationship: "",
      address: "",
      email: "",
      phoneNumber: "",
    };
    setMyContactsList([...myContactsList, newRow]);
  };

  const removeMyContactsListRow = (id) => {
    const newRows = myContactsList.filter((row) => row.id !== id);
    setMyContactsList(newRows);
  };

  const handleMyContactsListInputChange = (id, field, value) => {
    const updatedRows = myContactsList.map((row) =>
      row.id === id ? { ...row, [field]: value } : row
    );
    setMyContactsList(updatedRows);
  };
  return (
    <>
      <form onSubmit={handleSubmit}>
        <Modal.Body>
          <div className="formBlockContent">
            <div className="row">

              {(sectionContentID === "myTenancyInformation" ||
                sectionContentID === "missingPersonsProfile" ||
                sectionContentID === "personalInventory" ||
                sectionContentID === "afterMyDeath" ||
                sectionContentID === "financialRecords") && (
                  <>
                    <div className="col-md-12">
                      <div className="form-group">
                        <input
                          name="fileName"
                          id="fileName"
                          type="file"
                          accept=".pdf, .doc, .docx"
                          onChange={handleFileUpload}
                        />
                        {fileSizeError && (
                          <div className="validationError">
                            <div className="text-danger">
                              Error: File size exceeds the 5MB limit. Please upload a smaller file.
                            </div>
                          </div>
                        )}

                      </div>
                    </div>
                  </>
                )}

              {
                sectionContentID != "myContacts" && (
                  <>
                    <div className="col-md-12">
                      <div className="pbsFieldWrapper">
                        <JoditEditor
                          name="sectionContentData"
                          ref={editor}
                          tabIndex={1}
                          // value={sectionContentData}
                          value={values[modalPopupData?.sectionId]}
                          onChange={handleOnChangeEditor}
                        // onBlur={handleBlur}
                        />
                      </div>
                    </div>
                  </>
                )
              }

              {myContactListStatus && (
                <>
                  <div className="myContactsPoints">
                    <div className="table-responsive">
                      <Table bordered className='dynamicRows'>
                        <tbody>
                          {myContactsList.map((row, id) => (
                            <tr>
                              <td>
                                <h3>Enter Contact Details</h3>
                                <div className="row">
                                  <div className="col-md-6">
                                    <Input
                                      type="text"
                                      id={`name_${row.id}`}
                                      name={`name_${row.id}`}
                                      value={row.name}
                                      onChange={(e) => handleMyContactsListInputChange(row.id, 'name', e.target.value)}
                                      labelText="Name"
                                      onBlur={handleBlur}
                                    />
                                  </div>
                                  <div className="col-md-6">
                                    <SelectBox
                                      id={`relationship_${row.id}`}
                                      name={`relationship_${row.id}`}
                                      value={row.relationship}
                                      onChange={(e) => handleMyContactsListInputChange(row.id, 'relationship', e.target.value)}
                                      onBlur={handleBlur}
                                      options={relationshipOptions}
                                      labelText="Relationship"
                                    />
                                  </div>

                                  <div className="col-md-6">
                                    <Input
                                      type="email"
                                      id={`email_${row.id}`}
                                      name={`email_${row.id}`}
                                      value={row.email}
                                      onChange={(e) => handleMyContactsListInputChange(row.id, 'email', e.target.value)}
                                      labelText="Email"
                                      onBlur={handleBlur}
                                    />
                                  </div>
                                  <div className="col-md-6">
                                    <Input
                                      type="number"
                                      id={`phoneNumber_${row.id}`}
                                      name={`phoneNumber_${row.id}`}
                                      value={row.phoneNumber}
                                      onChange={(e) => handleMyContactsListInputChange(row.id, 'phoneNumber', e.target.value)}
                                      labelText="Phone Number"
                                      onBlur={handleBlur}
                                    />
                                  </div>
                                  <div className="col-md-12">
                                    <Input
                                      type="text"
                                      id={`address_${row.id}`}
                                      name={`address_${row.id}`}
                                      value={row.address}
                                      onChange={(e) => handleMyContactsListInputChange(row.id, 'address', e.target.value)}
                                      labelText="Address"
                                      onBlur={handleBlur}
                                    />
                                  </div>
                                </div>
                              </td>
                              <td><img className='removeRow' src={eventClose} alt="Close" onClick={() => { removeMyContactsListRow(row.id) }} /></td>
                            </tr>
                          ))}
                        </tbody>
                        <tfoot>
                          <tr>
                            <td></td>
                            <td><img className='addRow' src={eventAdd} alt="Add" onClick={addMyContactsListRow} /></td>
                          </tr>
                        </tfoot>
                      </Table>
                    </div>
                  </div>

                </>
              )
              }
              <OverlayTrigger
                placement="bottom"
                delay={{ show: 250, hide: 400 }}
                overlay={renderTooltip}
              >
                <span className="">asdf sdafsd fsdf sdaf dfsdf
                  &nbsp;
                  <img
                    className="curSorPointer"
                    src={infoIcon}
                    alt="Information"
                  />
                </span>
              </OverlayTrigger>
            </div>
          </div>

        </Modal.Body>
        <Modal.Footer>
          <div className="formActionButtons">

            <span
              className="btn btn-sm btn-outline-primary"
              onClick={handelModalPopupClose}
            >
              Cancel
            </span>
            {isSubmitButtonClicked ? (
              <Button
                className="btn-sm"
                variant="primary"
                disabled
              >
                Loading...
              </Button>
            ) : (
              <Button className="btn-sm" variant="primary" type="submit">
                Submit
              </Button>
            )}
          </div>
        </Modal.Footer>
      </form>

      {isToastAddPbsPlans && <ToastContainer />}
    </>
  );
}

export default AddCarePlanPopUp